module.exports = __webpack_public_path__ + "CADR_Web.43526c8c3844f2057851.png";